import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@RankHR/Emails/commands-core'
import { isRef, ref, Ref } from 'vue'

export function useSendEmailCommandV1(
	subject?: string | Ref<string> | (() => string), 
	messageHtml?: string | Ref<string> | (() => string), 
	recipientsIds?: any | Ref<any> | (() => any), 
	includeSurveyLink?: boolean | Ref<boolean> | (() => boolean), 
	includeReportLink?: boolean | Ref<boolean> | (() => boolean), 
) 
{
	const _subject = isRef<string>(subject) ? subject : ref<string>((typeof subject === 'function') ? subject() : subject)
	const _messageHtml = isRef<string>(messageHtml) ? messageHtml : ref<string>((typeof messageHtml === 'function') ? messageHtml() : messageHtml)
	const _recipientsIds = isRef<any>(recipientsIds) ? recipientsIds : ref<any>((typeof recipientsIds === 'function') ? recipientsIds() : recipientsIds)
	const _includeSurveyLink = isRef<boolean>(includeSurveyLink) ? includeSurveyLink : ref<boolean>((typeof includeSurveyLink === 'function') ? includeSurveyLink() : includeSurveyLink)
	const _includeReportLink = isRef<boolean>(includeReportLink) ? includeReportLink : ref<boolean>((typeof includeReportLink === 'function') ? includeReportLink() : includeReportLink)

	const result = {
		subject: _subject,
		messageHtml: _messageHtml,
		recipientsIds: _recipientsIds,
		includeSurveyLink: _includeSurveyLink,
		includeReportLink: _includeReportLink,

		...useCommand(() => {
			if (typeof subject === 'function') { _subject.value = subject() }
			if (typeof messageHtml === 'function') { _messageHtml.value = messageHtml() }
			if (typeof recipientsIds === 'function') { _recipientsIds.value = recipientsIds() }
			if (typeof includeSurveyLink === 'function') { _includeSurveyLink.value = includeSurveyLink() }
			if (typeof includeReportLink === 'function') { _includeReportLink.value = includeReportLink() }

			return new c.SendEmailCommandV1(_subject.value, _messageHtml.value, _recipientsIds.value, _includeSurveyLink.value, _includeReportLink.value)
		})
	}

	return {
		...result,
		authorizedSendEmailCommandV1: result.authorized,
		sendEmailCommandV1: result.command,
		completedSendEmailCommandV1: result.completed,
		errorSendEmailCommandV1: result.error,
		invokeSendEmailCommandV1: result.invoke,
		invokingSendEmailCommandV1: result.invoking,
		succeedSendEmailCommandV1: result.succeed,
		validationErrorsSendEmailCommandV1: result.validationErrors,
		onSucceedSendEmailCommandV1: result.onSucceed,
	}
}

